/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {surveyRespondentsGet, SurveyRespondentsGetParams} from "../fn/survey-respondent/survey-respondents-get";
import {PaginatedList} from "../models/paginator/paginated-list";
import {
    SurveyRespondentDetailsGetParams,
    surveyRespondentsQuestionnairesGet
} from "../fn/survey-respondent/survey-respondent-details-get";
import {SurveyRespondentModel} from "../models/survey-respondent-model";
import {
    surveyRespondentQuestionnairesGet,
    SurveyRespondentsQuestionnairesGetParams
} from "../fn/survey-respondent/survey-respondent-questionnaires-get";
import {SurveyRespondentQuestionnaireModel} from "../models/survey-respondent-questionnaire-model";
import {
    surveyRespondentAssociatedQuestionnairesGet,
    SurveyRespondentAssociatedQuestionnairesGetParams
} from "../fn/survey-respondent/survey-respondent-associated-questionnaires-get";
import {
    surveyRespondentScheduledQuestionnairesGet
} from "../fn/survey-respondent/survey-respondent-scheduled-questionnaires-get";
import {SurveyRespondentScheduledQuestionnaireModel} from "../models/survey-respondent-scheduled-questionnaire-model";
import {SurveyRespondentPutParams, surveyRespondentsPut} from "../fn/survey-respondent/survey-respondents-put";

@Injectable({ providedIn: 'root' })
export class SurveyRespondentService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Gets survey respondents instances for an account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `surveyRespondentsGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentsGet$Response(headers: HttpHeaders, params: SurveyRespondentsGetParams, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentModel>>> {
        return surveyRespondentsGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets survey respondents for an account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `surveyRespondentsGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentsGet(headers: HttpHeaders, params: SurveyRespondentsGetParams, context?: HttpContext): Observable<PaginatedList<SurveyRespondentModel>> {
        return this.surveyRespondentsGet$Response(headers, params, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentModel>>): PaginatedList<SurveyRespondentModel> => r.body)
        );
    }

    /**
     * Gets survey respondent details
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentDetailsGet(headers: HttpHeaders, params: SurveyRespondentDetailsGetParams, context?: HttpContext): Observable<SurveyRespondentModel> {
        return surveyRespondentsQuestionnairesGet(this.http, this.rootUrl, params, headers, context).pipe(
            map((r: StrictHttpResponse<SurveyRespondentModel>): SurveyRespondentModel => r.body)
        );
    }

    /**
     * Gets survey respondent questionnaires
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentQuestionnairesGet(headers: HttpHeaders, params: SurveyRespondentsQuestionnairesGetParams, context?: HttpContext): Observable<PaginatedList<SurveyRespondentQuestionnaireModel>> {
        return surveyRespondentQuestionnairesGet(this.http, this.rootUrl, params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>): PaginatedList<SurveyRespondentQuestionnaireModel> => r.body)
        );
    }

    /**
     * Gets survey respondent associated questionnaires
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentAssociatedQuestionnairesGet(headers: HttpHeaders, params: SurveyRespondentAssociatedQuestionnairesGetParams, context?: HttpContext): Observable<PaginatedList<SurveyRespondentQuestionnaireModel>> {
        return surveyRespondentAssociatedQuestionnairesGet(this.http, this.rootUrl, params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>): PaginatedList<SurveyRespondentQuestionnaireModel> => r.body)
        );
    }

    /**
     * Gets survey respondent scheduled questionnaires
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentScheduledQuestionnairesGet(headers: HttpHeaders, params: SurveyRespondentsQuestionnairesGetParams, context?: HttpContext): Observable<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>> {
        return surveyRespondentScheduledQuestionnairesGet(this.http, this.rootUrl, params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>>): PaginatedList<SurveyRespondentScheduledQuestionnaireModel> => r.body)
        );
    }

    /**
     * Updates a survey respondent
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    surveyRespondentsPut(headers: HttpHeaders, params: SurveyRespondentPutParams, context?: HttpContext): Observable<void> {
        return surveyRespondentsPut(this.http, this.rootUrl, params, headers, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body)
        );
    }
}
